import * as React from "react";
import Store from "logic/local-storage/Store";
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from "common/contexts";
import { LOCAL_STORAGE_ITEM } from "security-app/hooks/api/securityEventsAPI.types";
import AlertsEntityTable from "security-app/components/SecurityEvents/Alerts/AlertsEntityTable";
import AlertsModals from "./AlertsModals";
function Index() {
  const lastSearch = Store.get(LOCAL_STORAGE_ITEM);
  return /* @__PURE__ */ React.createElement(PaginationProvider, { initFilters: lastSearch ? { alerts: lastSearch.alerts, timerange: lastSearch.timerange } : {} }, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(AlertsEntityTable, null), /* @__PURE__ */ React.createElement(AlertsModals, null))));
}
export default Index;
